import {
  GET_DIVISIONS_WATCHER,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_FAILED,
  GET_DIVISIONS_BY_DIMENSION_WATCHER,
  GET_DIVISIONS_BY_DIMENSION_SUCCESS,
  GET_DIVISIONS_BY_DIMENSION_FAILED,
} from "./constants"

export function getDivisionsWatcher(payload) {
  return {
    type: GET_DIVISIONS_WATCHER,
    payload,
  }
}

export function getDivisionsSuccess(payload) {
  return {
    type: GET_DIVISIONS_SUCCESS,
    payload,
  }
}

export function getDivisionsFailed() {
  return { type: GET_DIVISIONS_FAILED }
}

export function getDivisionsByDimensionWatcher(payload) {
  return {
    type: GET_DIVISIONS_BY_DIMENSION_WATCHER,
    payload,
  }
}

export function getDivisionsByDimensionSuccess(payload) {
  return {
    type: GET_DIVISIONS_BY_DIMENSION_SUCCESS,
    payload,
  }
}

export function getDivisionsByDimensionFailed() {
  return {
    type: GET_DIVISIONS_BY_DIMENSION_FAILED,
  }
}
